const FooterCopyrites = () => {
    return (
        <div className="footer-features">
            <p>Todos os direitos reservados: @Cintespb.Br</p>
        </div>
    );
};
export default FooterCopyrites;
